module.exports = "/_next/static/images/PredictiveAIModels@2x-2acc10c3f7d408d84cd15392afd082d2.png";